import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
import { getToken } from "helpers/Tokens";

const initialState: any = {
  vehicleList: [],
  loading:false
};

export const getVehicleDetails:any = createAsyncThunk<any>(
  "getVehicleDetails/setVehicleDetails",
  async (_, thunkAPI) => {
    try {
      let userData= getToken();
      const response = await ApiClient.get(`vehicle?limit=100&verified=true&userId=${userData?.id}`);
      return response?.data?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const vehicleDetailsSlice = createSlice({
  name: "getVehicleDetails",
  initialState,
  reducers: {
    setVehicleDetails(state, action) {
      state.vehicleList = action.payload;
    },
  },
  extraReducers: {
    [getVehicleDetails.pending]: (state:any) => {
      state.loading = true
    },
    [getVehicleDetails.fulfilled]: (state:any, action: any) => {
      state.loading = false
      state.vehicleList = action.payload;
    },
    [getVehicleDetails.rejected]: (state:any) => {
      state.loading = false
    },
  },
});

export const { setVehicleDetails } = vehicleDetailsSlice.actions;
export default vehicleDetailsSlice;
